import { Text } from '@mantine/core';
import React, { FC } from 'react';

import { AuditLogType } from '@portals/types';

interface CreateIntegrationProps {
  auditLog: AuditLogType;
}

export const CreateIntegration: FC<CreateIntegrationProps> = ({ auditLog }) => (
  <Text size="sm">
    Created {auditLog?.params[0]?.model}: {auditLog?.params[0]?.display_name}
  </Text>
);
